<ng-container [ngSwitch]="controlTemplate?.type">
    
    <ng-container *ngSwitchCase="'checkBoxInput'">
        <app-checkboxInput-control-label-view
            [controlTemplate]="controlTemplate">
        </app-checkboxInput-control-label-view>
    </ng-container>

    <ng-container *ngSwitchCase="'numberInput'">
        <app-numberInput-control-label-view
            [controlTemplate]="controlTemplate">
        </app-numberInput-control-label-view>
    </ng-container>

    <ng-container *ngSwitchCase="'refuelInput'">
        <app-refuelInput-control-label-view
            [controlTemplate]="controlTemplate">
        </app-refuelInput-control-label-view>
    </ng-container>

    <ng-container *ngSwitchCase="'fuelInput'">
        <app-fuelInput-control-label-view
            [controlTemplate]="controlTemplate">
        </app-fuelInput-control-label-view>
    </ng-container>

    <ng-container *ngSwitchCase="'chargeInput'">
        <app-chargeInput-control-label-view
            [controlTemplate]="controlTemplate">
        </app-chargeInput-control-label-view>
    </ng-container>

    <ng-container *ngSwitchCase="'pictureInput'">
        <app-pictureInput-control-label-view
            [controlTemplate]="controlTemplate">
        </app-pictureInput-control-label-view> 
    </ng-container>

    <ng-container *ngSwitchCase="'picturesInput'">
        <app-picturesInput-control-label-view
            [controlTemplate]="controlTemplate">
        </app-picturesInput-control-label-view> 
    </ng-container>

    <ng-container *ngSwitchCase="'commentInput'">
        <app-commentInput-control-label-view
            [controlTemplate]="controlTemplate">
        </app-commentInput-control-label-view>
    </ng-container>

    <ng-container *ngSwitchCase="'signatureInput'">
        <app-signatureInput-control-label-view
            [controlTemplate]="controlTemplate">
        </app-signatureInput-control-label-view>
    </ng-container>

    <ng-container *ngSwitchCase="'selectInput'">
        <app-selectInput-control-label-view
            [controlTemplate]="controlTemplate">
        </app-selectInput-control-label-view>
    </ng-container>

    <ng-container *ngSwitchCase="'textInput'">
        <app-textInput-control-label-view
            [controlTemplate]="controlTemplate">
        </app-textInput-control-label-view>
    </ng-container>

    <ng-container *ngSwitchCase="'rangeInput'">
        <app-rangeInput-control-label-view
            [controlTemplate]="controlTemplate">
        </app-rangeInput-control-label-view>
    </ng-container>

    <ng-container *ngSwitchCase="'timeEntriesInput'">
        <app-timeEntriesInput-control-label-view
            [controlTemplate]="controlTemplate">
        </app-timeEntriesInput-control-label-view>
    </ng-container>

    <ng-container *ngSwitchCase="'issueInput'">
        <app-issueInput-control-label-view
            [controlTemplate]="controlTemplate">
        </app-issueInput-control-label-view>
    </ng-container>

    <ng-container *ngSwitchDefault>
        missing {{controlTemplate?.type}}
    </ng-container>
</ng-container>